<template>
    <div>
        <van-empty description="暂未开放" />
    </div>
</template>

<script>
    export default {
        name: "NotOpen"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/common/NotOpen.vue